import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useSettings = () =>
  useQuery({ queryKey: ["settings"], queryFn: async () => (await api.get("/settings")).data });

export const useDocuments = (params) =>
  useQuery({ queryKey: ["documents", params], queryFn: async () => (await api.get("/documents", { params })).data });

export const useDocument = (id) =>
  useQuery({ queryKey: ["document", id], queryFn: async () => (await api.get(`/documents/${id}`)).data, enabled: !!id });

export const useStats = () =>
  useQuery({ queryKey: ["stats"], queryFn: async () => (await api.get("/documents/stats")).data });
